import styled from 'styled-components'

export const HeaderContainer = styled.header`
  width: 100%;
  height: 4rem;
  background-color: #1985A1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`